function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import { resendVerificationEmail } from '../actions';

/**
 * Asks Megatron to send a fresh verification link, which retires the previous one.
 *
 * The button is disabled once used, so an impatient click doesn't invalidate the
 * link that is already on its way to the inbox.
 *
 * It reads as a sentence on the login notice and as a button on the pending page,
 * so the caller supplies the styling, the label and any icon.
 */
var ResendVerificationEmail = function ResendVerificationEmail(_ref) {
  var email = _ref.email,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'btn btn-link p-0 align-baseline' : _ref$className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'rubriq.send-me-a-new-verification-email' : _ref$label;
  var dispatch = useDispatch();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sending = _useState2[0],
    setSending = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    sent = _useState4[0],
    setSent = _useState4[1];
  if (!email) {
    return null;
  }
  var handleResend = function handleResend() {
    setSending(true);
    dispatch(resendVerificationEmail(email)).then(function () {
      return setSent(true);
    }).finally(function () {
      return setSending(false);
    });
  };
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: className,
    disabled: sending || sent,
    onClick: handleResend,
    "data-test": "resend-verification-email"
  }, icon && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon
  }), sent ? /*#__PURE__*/React.createElement(T, {
    source: "rubriq.verification-email-sent"
  }) : /*#__PURE__*/React.createElement(T, {
    source: label
  }));
};
export default ResendVerificationEmail;